import {
  IconHierarchy2,
  IconChartPie,
  IconTrendingUp,
  IconWallet,
  IconScale,
  IconBriefcase,
  IconPuzzle,
  IconBrain,
  IconGavel,
  IconSpaces
} from '@tabler/icons-react'

export const PROJECT_MAX_LENGTH = 80

export const INSTRUCTIONS_MAX_LENGTH = 5000

export const PROJECT_ICONS = [
  { id: 'spaces', Icon: IconSpaces, label: 'Spaces' },
  { id: 'hierarchy', Icon: IconHierarchy2, label: 'Hierarchy' },
  { id: 'chart-pie', Icon: IconChartPie, label: 'Pie chart' },
  { id: 'trending-up', Icon: IconTrendingUp, label: 'Trend' },
  { id: 'wallet', Icon: IconWallet, label: 'Wallet' },
  { id: 'scale', Icon: IconScale, label: 'Scale' },
  { id: 'briefcase', Icon: IconBriefcase, label: 'Briefcase' },
  { id: 'puzzle', Icon: IconPuzzle, label: 'Puzzle' },
  { id: 'brain', Icon: IconBrain, label: 'Brain' },
  { id: 'gavel', Icon: IconGavel, label: 'Gavel' }
]

export const PROJECT_COLOURS = [
  { id: 'yellow', value: '#E6C84F' },
  { id: 'orange', value: '#E08A3A' },
  { id: 'coral', value: '#D05F4F' },
  { id: 'purple', value: '#9B6FB0' },
  { id: 'blue', value: '#5C7CA6' },
  { id: 'green', value: '#4C9C6F' },
  { id: 'light-gray', value: '#B7C2C7' },
  { id: 'dark-slate', value: '#3F4F55' }
]

/**
 * Project memory modes mirror the API `memoryMode` enum.
 *   0 = Default     – standard memory behaviour
 *   1 = ProjectOnly – memory scoped to the project only
 *   2 = Off         – memory disabled
 *
 * Note: request bodies (POST/PUT) use the numeric `value`, while list/get
 * responses return the string `name` (e.g. "Default"). Use `resolveMemoryMode`
 * to normalise either form back to the numeric value the UI works with.
 */
export const PROJECT_MEMORY_MODES = [
  { value: 0, name: 'Default', label: 'Default' },
  { value: 1, name: 'ProjectOnly', label: 'Project only' },
  { value: 2, name: 'Off', label: 'Off' }
]

/** Normalise a memoryMode that may arrive as a number (request enum) or string ("Default") to its numeric value. */
export const resolveMemoryMode = (mode?: number | string): number => {
  if (typeof mode === 'number') {
    return (
      PROJECT_MEMORY_MODES.find((m) => m.value === mode)?.value ?? PROJECT_MEMORY_MODES[0].value
    )
  }
  return PROJECT_MEMORY_MODES.find((m) => m.name === mode)?.value ?? PROJECT_MEMORY_MODES[0].value
}

/** Resolve the tabler icon component for a stored project icon id. Falls back to the first icon. */
export const getProjectIcon = (iconId?: string) =>
  (PROJECT_ICONS.find((i) => i.id === iconId) ?? PROJECT_ICONS[0]).Icon

/** Resolve the hex value for a stored project colour id. Falls back to the first colour. */
export const getProjectColour = (colourId?: string) =>
  (PROJECT_COLOURS.find((c) => c.id === colourId) ?? PROJECT_COLOURS[0]).value
